import { makeCurrentItemActions } from 'utils/factory'

const baseItemActions = makeCurrentItemActions('storeTemplates', {
  storePath: 'templateStore.current',
})
export const fetchTemplate = (id: string) => baseItemActions.fetch(id)
